import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["visibility"]

  showHide ({ key, ctrlKey, altKey }) {
    if (ctrlKey && altKey && key === "d") {
      this.element.classList.toggle(this.visibilityClass)
    }
  }
}
